import { useTranslation } from 'react-i18next';
import { ApprovalFormTable } from '@/components/Approval/@components/ApprovalFormTable';
import type { LeaveBalance } from '@/utils/approval/annualLeaveRequest';

// 영어 머리글이 단어 중간에서 끊기지 않게
const keepAll = { wordBreak: 'keep-all' } as const;

/** 레거시 휴가 사용현황 표 — 월차·연차 부여/사용, 전년초과 사용, 잔여 휴가 */
export const LeaveBalanceTable = ({ balance }: { balance: LeaveBalance }) => {
  const { t } = useTranslation();
  return (
    <ApprovalFormTable>
      <tbody>
        <tr>
          <th style={keepAll} colSpan={2}>
            {t('월차')}
          </th>
          <th style={keepAll} colSpan={2}>
            {t('연차')}
          </th>
          <th style={keepAll} rowSpan={2}>
            {t('전년초과 사용')}
          </th>
          <th style={keepAll} rowSpan={2}>
            {t('잔여 휴가')}
          </th>
        </tr>
        <tr>
          <th style={keepAll}>{t('부여')}</th>
          <th style={keepAll}>{t('사용')}</th>
          <th style={keepAll}>{t('부여')}</th>
          <th style={keepAll}>{t('사용')}</th>
        </tr>
        <tr>
          <td className="text-center">{balance.monthlyLeave.granted}</td>
          <td className="text-center">{balance.monthlyLeave.used}</td>
          <td className="text-center">{balance.annualLeave.granted}</td>
          <td className="text-center">{balance.annualLeave.used}</td>
          <td className="text-center">{balance.overage}</td>
          <td className="text-center">
            <strong>{balance.remaining}</strong>
          </td>
        </tr>
      </tbody>
    </ApprovalFormTable>
  );
};

export const LEAVE_BALANCE_HINTS = [
  '* 월차: 1년 미만 근로자에게 부여되는 휴가로, 입사일 기준으로 1년까지만 부여',
  '* 연차: 회계연도 기준으로 부여되는 휴가로, 매년 1월1일에 전년도 만근월수에 비례하여 부여',
  '* 잔여: (월차・연차 부여일수) – (월차・연차 사용일수 + 전년도 초과사용분)',
  '* 사용일수 계산 시 휴일 및 임시공휴일은 제외, 월차부터 우선 차감',
];
